<div class="table-header-wrapper">
  <ng-content></ng-content>
</div>
